import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Dialog from '../../common/components/Dialog';
import { withTranslation } from 'react-i18next';
import { fetchWeeklyProgramItem } from '../../dashboard/common/actions';
import ReduxBlockUi from 'react-block-ui/redux';
import { WEEKLY_PROGRAM_ITEM_REQUEST, WEEKLY_PROGRAM_ITEM_SUCCESS, WEEKLY_PROGRAM_ITEM_FAILURE } from '../../dashboard/common/actions';

class ClassDetailsLink extends Component {
	constructor(props) {
		super(props);
		this.showInfoDialog = this.showInfoDialog.bind(this);
		this.hideInfoDialog = this.hideInfoDialog.bind(this);
		this.state = {
			showInfoDialog: false
		};
	}

	showInfoDialog() {
		const { programItem, fetchWeeklyProgramItem } = this.props;
		// load program item details if not already loaded, to get the theme description for the dialog body
		if (programItem && programItem.id && programItem.centerId) {
			fetchWeeklyProgramItem(programItem.centerId, programItem.id);
		}
		this.setState({
			showInfoDialog: true
		});
	}

	hideInfoDialog() {
		this.setState({
			showInfoDialog: false
		});
	}

	renderInfoDialog() {
		const { programItem, weeklyProgramDetails } = this.props;
		const grade = programItem && programItem.grade;

		const term = programItem && programItem.term;
		const themeDescription = weeklyProgramDetails && weeklyProgramDetails.themeDescription ||
			(term && term.themeDescription);

		const header = programItem && (programItem.name || (grade && grade.name));
		const body = <ReduxBlockUi block={WEEKLY_PROGRAM_ITEM_REQUEST} unblock={[WEEKLY_PROGRAM_ITEM_SUCCESS, WEEKLY_PROGRAM_ITEM_FAILURE]} renderChildren={false}>
			<div>
				{themeDescription && <div dangerouslySetInnerHTML={{ __html: themeDescription }} style={{ marginBottom: '20px' }} />}
				{grade && grade.description && <div dangerouslySetInnerHTML={{ __html: grade.description }} />}
			</div>
		</ReduxBlockUi>;

		return <Dialog show={this.state.showInfoDialog} onHide={this.hideInfoDialog} header={header} body={body} />;
	}

	render() {
		const { programItem } = this.props;
		const grade = programItem && programItem.grade;
		const displayName = programItem && (programItem.name || (grade && grade.name));
		const infoDialog = this.renderInfoDialog();

		return displayName ? <span>
			<a style={{ cursor: 'pointer' }} onClick={this.showInfoDialog}>{displayName}</a>
			{infoDialog}
		</span> : null;
	}
}

ClassDetailsLink.propTypes = {
	programItem: PropTypes.shape({
		id: PropTypes.number,
		centerId: PropTypes.number,
		name: PropTypes.string,
		grade: PropTypes.shape({
			id: PropTypes.number,
			name: PropTypes.string,
			description: PropTypes.string
		}),
		term: PropTypes.shape({
			themeDescription: PropTypes.string
		})
	}),
	weeklyProgramDetails: PropTypes.object,
	fetchWeeklyProgramItem: PropTypes.func
};

const mapStateToProps = (state, ownProps) => {
	const programId = ownProps.programItem && ownProps.programItem.id;
	return {
		weeklyProgramDetails: programId && state.entities.weeklyProgram[programId]
	};
};

export default connect(mapStateToProps, { fetchWeeklyProgramItem })(withTranslation()(ClassDetailsLink));
